import swal from "sweetalert2";
import { formatSize } from "utils/files.js";

export async function alertFileSizeExceeded(fieldName, fileSize, maxSize) {
	try {
		await swal.fire({
			title: fieldName || "File too large",
			html: `The selected file (${formatSize(fileSize)}) exceeds the maximum allowed size of <strong>${formatSize(maxSize)}</strong>.`,
			showCloseButton: true,
			type: "warning",
			confirmButtonColor: "#8CC541",
			confirmButtonText: "OK"
		});
	}catch(error) {
		return;
	}
}
